var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 1.64001C14.15 1.64001 16.55 2.63002 18.4 4.24002L20.29 2.35001C20.92 1.72001 22 2.16001 22 3.05001V8.64001C22 9.19001 21.55 9.64001 21 9.64001H15.41C14.52 9.64001 14.07 8.56001 14.7 7.93001L16.61 6.02001C15.22 4.86001 13.45 4.14001 11.49 4.14001C8.33 4.14001 5.6 5.98001 4.3 8.64001C4.03 9.20001 3.39 9.48001 2.8 9.28001C2.09 9.05001 1.73 8.24001 2.05 7.56001C3.77 4.06001 7.35 1.64001 11.5 1.64001Z",
    fill: "#0C2128"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4663 22.36C9.81631 22.36 7.41631 21.37 5.56631 19.76L3.67631 21.65C3.04631 22.28 1.96631 21.84 1.96631 20.95L1.96631 15.36C1.96631 14.81 2.41631 14.36 2.96631 14.36L8.55631 14.36C9.44631 14.36 9.89631 15.44 9.26631 16.07L7.35631 17.98C8.74631 19.14 10.5163 19.86 12.4763 19.86C15.6363 19.86 18.3663 18.02 19.6663 15.36C19.9363 14.8 20.5763 14.52 21.1663 14.72C21.8763 14.95 22.2363 15.76 21.9163 16.44C20.1963 19.94 16.6163 22.36 12.4663 22.36Z",
    fill: "#0C2128"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.e9e145a9695b5737200151ff53a7b03c.svg";
export { ForwardRef as ReactComponent };